import React, { memo } from 'react';
import { graphql } from 'gatsby';
import { RichText } from 'prismic-reactjs';
import { serializeHyperlink } from '../../../utils/helpers';
import { htmlSerializer } from '../../../utils/htmlSerializer';

const TextBlock = memo(({ slice, index, ...props }) => {
  return (
    <>
      {props[`before__${slice.slice_type}__${index}`]}
      <section className={`${slice.slice_type}`}>
        <RichText
          render={slice.primary.text.richText}
          htmlSerializer={htmlSerializer}
          serializeHyperlink={serializeHyperlink}
        />
      </section>
      {props[`after__${slice.slice_type}__${index}`]}
    </>
  );
});

export default TextBlock;

export const query = graphql`
  fragment BlogPostNewDataBodyTextBlock on PrismicBlogPostNewDataBodyTextBlock {
    primary {
      text {
        richText
      }
    }
  }
`;
